import React from "react";
import type { LinkProps } from "react-router";
import { Link } from "react-router";
import { classNames } from "../styles/classNames";

type TopbarControlBaseProps = {
  className?: string;
  children: React.ReactNode;
};

type TopbarControlButtonProps = TopbarControlBaseProps &
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    as?: "button";
  };

type TopbarControlLinkProps = TopbarControlBaseProps &
  Omit<LinkProps, "className"> & {
    as: "link";
  };

type TopbarControlProps = TopbarControlButtonProps | TopbarControlLinkProps;

export default function TopbarControl(props: TopbarControlProps) {
  if (props.as === "link") {
    const { className, children, as, ...linkProps } = props;
    return (
      <Link
        className={classNames("app-topbar-action app-topbar-nav-button", className)}
        {...linkProps}
      >
        {children}
      </Link>
    );
  }

  const { className, children, as, type = "button", ...buttonProps } = props;
  return (
    <button
      type={type}
      className={classNames("app-topbar-action app-topbar-nav-button", className)}
      {...buttonProps}
    >
      {children}
    </button>
  );
}

